import { AuthScopeBase, AvengersRole, CrudOp, DifferentiationType, ProjectDifferentiatedAuthScope } from "../authHelperTypes";

const CRUD = Object.values(CrudOp);
const CRU = [CrudOp.CREATE, CrudOp.READ, CrudOp.UPDATE];
const CR = [CrudOp.CREATE, CrudOp.READ];
const R = [CrudOp.READ];

const projectDifferentiated = (mappings: AuthScopeBase["mappings"]): ProjectDifferentiatedAuthScope => ({
  type: DifferentiationType.PROJECT,
  mappings,
});

// @formatter:off
// differentiation type: PROJECT
/* eslint-disable @stylistic/key-spacing */
export const bomUpdateAuthScope = projectDifferentiated({
  [AvengersRole.PROJECT_MANAGER]:     CRUD,
  [AvengersRole.LIBRARY_OPERATOR]:    CRUD,
  [AvengersRole.OPERATOR]:            CRUD,
  [AvengersRole.OPERATOR_EDITORIAL]:  R,
  [AvengersRole.READER]:              R,
});

export const fakomAuthScope = projectDifferentiated({
  [AvengersRole.PROJECT_MANAGER]:     CRUD,
  [AvengersRole.LIBRARY_OPERATOR]:    R,
  [AvengersRole.OPERATOR]:            CRUD,
  [AvengersRole.OPERATOR_EDITORIAL]:  CRU,
  [AvengersRole.READER]:              R,
});

export const megTemplateAuthScope = projectDifferentiated({
  [AvengersRole.PROJECT_MANAGER]:     CRUD,
  [AvengersRole.LIBRARY_OPERATOR]:    R,
  [AvengersRole.OPERATOR]:            CRUD,
  [AvengersRole.OPERATOR_EDITORIAL]:  R,
  [AvengersRole.READER]:              R,
});

export const partlistEntryAuthScope = projectDifferentiated({
  [AvengersRole.PROJECT_MANAGER]:     CRUD,
  [AvengersRole.LIBRARY_OPERATOR]:    CRUD,
  [AvengersRole.OPERATOR]:            CRUD,
  [AvengersRole.OPERATOR_EDITORIAL]:  CRU,
  [AvengersRole.READER]:              R,
});

export const plmxmlAuthScope = projectDifferentiated({
  [AvengersRole.PROJECT_MANAGER]:     CRUD,
  [AvengersRole.LIBRARY_OPERATOR]:    CR,
  [AvengersRole.OPERATOR]:            CRUD,
  [AvengersRole.OPERATOR_EDITORIAL]:  CR,
});

export const projectManagementAuthScope = projectDifferentiated({
  [AvengersRole.PROJECT_MANAGER]:     CRUD,
  [AvengersRole.LIBRARY_OPERATOR]:    R,
  [AvengersRole.OPERATOR]:            R,
  [AvengersRole.OPERATOR_EDITORIAL]:  R,
  [AvengersRole.READER]:              R,
});

export const projectStructureAuthScope = projectDifferentiated({
  [AvengersRole.PROJECT_MANAGER]:     CRUD,
  [AvengersRole.LIBRARY_OPERATOR]:    R,
  [AvengersRole.OPERATOR]:            CRUD,
  [AvengersRole.OPERATOR_EDITORIAL]:  R,
  [AvengersRole.READER]:              R,
});

export const qaSuiteAuthScope = projectDifferentiated({
  [AvengersRole.PROJECT_MANAGER]:     CRUD,
  [AvengersRole.LIBRARY_OPERATOR]:    CRUD,
  [AvengersRole.OPERATOR]:            CRUD,
  [AvengersRole.OPERATOR_EDITORIAL]:  CRUD,
  [AvengersRole.READER]:              R,
});

export const tmmAuthScope = projectDifferentiated({
  [AvengersRole.PROJECT_MANAGER]:     CRUD,
  [AvengersRole.LIBRARY_OPERATOR]:    R,
  [AvengersRole.OPERATOR]:            CRUD,
  [AvengersRole.OPERATOR_EDITORIAL]:  R,
  [AvengersRole.READER]:              R,
});

export const vehicleReleaseAuthScope = projectDifferentiated({
  [AvengersRole.PROJECT_MANAGER]:     CRUD,
  [AvengersRole.LIBRARY_OPERATOR]:    R,
  [AvengersRole.OPERATOR]:            R,
  [AvengersRole.OPERATOR_EDITORIAL]:  CRUD,
  [AvengersRole.READER]:              R,
});
